const getDefaultTierSelected = (isPlus?: boolean) => {
  if (isPlus) {
    return 'peak';
  }

  return 'plus';
};

export default getDefaultTierSelected;
